import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControlLabel,
  Switch
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const emptyState = {
  name: "",
  active: true
};

const SegmentModal = ({ open, onClose, segmentId, onSave }) => {
  const [record, setRecord] = useState(emptyState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    if (!segmentId) {
      setRecord(emptyState);
      return;
    }

    const loadRecord = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/segments/${segmentId}`);
        setRecord({
          name: data.name || "",
          active: data.active !== false
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toastError(err);
      }
    };

    loadRecord();
  }, [open, segmentId]);

  const handleSave = async () => {
    try {
      if (!record.name || !record.name.trim()) {
        toast.error("Nome é obrigatório");
        return;
      }

      setLoading(true);

      if (segmentId) {
        await api.put(`/segments/${segmentId}`, record);
        toast.success("Segmento atualizado com sucesso");
      } else {
        await api.post("/segments", record);
        toast.success("Segmento criado com sucesso");
      }

      setLoading(false);
      onSave && onSave();
      onClose();
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{segmentId ? "Editar Segmento" : "Novo Segmento"}</DialogTitle>

      <DialogContent dividers>
        <TextField
          fullWidth
          label="Nome"
          value={record.name}
          onChange={(e) => {
            const value = e.target.value;
            setRecord(prev => ({ ...prev, name: value }));
          }}
          disabled={loading}
        />

        <FormControlLabel
          style={{ marginTop: 16 }}
          control={
            <Switch
              checked={record.active}
              onChange={(e) => {
                const checked = e.target.checked;
                setRecord(prev => ({ ...prev, active: checked }));
              }}
              color="primary"
              disabled={loading}
            />
          }
          label="Ativo"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button color="primary" variant="contained" onClick={handleSave} disabled={loading}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SegmentModal;
